import React from 'react';
import PropTypes from 'prop-types';
import getQueryParam from 'core/utils/getQueryParam';
import {
	ReviewControlsContainer,
	ReviewsFilterContainer,
} from './reviewControlsStyles';

const sortOptions = {
	'most_relevant__desc': 'Most Relevant',
	'updated_at__desc': 'Most Recent',
	'rating__desc': 'High to Low Rating',
	'rating__asc': 'Low to High Rating',
};

const ratingOptions = {
	'None': 'All reviews',
	'1': '1 star',
	'2': '2 stars',
	'3': '3 stars',
	'4': '4 stars',
	'5': '5 stars',
};

const SortByDropdown = ({ forSeller }) => {
	const sortBy = getQueryParam('sort_by') || 'most_relevant__desc';
	const curSort = sortOptions[sortBy];
	const forParam = forSeller ? "seller" : "product";
	return (
		<ReviewsFilterContainer>
			<div className="dropdown">
				<button data-cj="dropdown">
					<span>{curSort}</span> <span className="caret"></span>
				</button>
				<ul className="dropdown-menu">
					{Object.keys(sortOptions).map(sort =>
						<li key={`review-sortBy-${sort}`}><a href={`?sort_by=${sort}&for=${forParam}`}>{sortOptions[sort]}</a></li>
					)}
				</ul>
			</div>
		</ReviewsFilterContainer>
	);
};

SortByDropdown.propTypes = {
	forSeller: PropTypes.bool,
};


const FilterByDropdown = ({ slug, forSeller }) => {
	const rating = getQueryParam('rating') || 'None';
	const curRating = ratingOptions[rating];
	const forParam = forSeller ? "seller" : "product";
	return (
		<ReviewsFilterContainer>
			<div className="dropdown">
				<button data-cj="dropdown">
					<span>{curRating}</span> <span className="caret"></span>
				</button>
				<ul className="dropdown-menu">
					<li><a href={`/subscription-box/${slug}/reviews/?for=${forParam}`}>All reviews</a></li>
					{Object.keys(ratingOptions).map(rate => rate !== 'None' &&
						<li key={`review-ratingFilter-${rate}`}>
							<a href={`?rating=${rate}&for=${forParam}`}>{ratingOptions[rate]}</a>
						</li>
					)}
				</ul>
			</div>
		</ReviewsFilterContainer>
	);
};

FilterByDropdown.propTypes = {
	slug: PropTypes.string.isRequired,
	forSeller: PropTypes.bool,
};


const ReviewControls = ({ slug, forSeller }) =>
	<ReviewControlsContainer>
		<SortByDropdown forSeller={forSeller} />
		<FilterByDropdown slug={slug} forSeller={forSeller} />
	</ReviewControlsContainer>;

ReviewControls.propTypes = {
	slug: PropTypes.string.isRequired,
	forSeller: PropTypes.bool,
};

export default ReviewControls;
